import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "../styles/VehiclePolicyForm.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import CONFIG from "../utils/config";

const currencyOptions = ["QAR"];

const MotorPolicy = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // Auto-refresh toggle (set this to false if you don't want auto-refresh)


  const { premium, mobileNumber, id } = location.state || {};
  const hasRetried = React.useRef(false);

  const initialVehicleDetails = {
    registrationNumber: "",
    chassisNumber: "",
    makeModel: "",
    manufacturingYear: "",
    expiryDate: null,
    vehicleValue: null,
    vehicleCylinder: null,
   // vehicleSeats: null,
  };

  const initialPolicyDetails = {
    insuredName: "",
    policyNumber: "",
    policyStartDate: null,
    policyExpiryDate: null,
    coverageType: ["Upgrade"],
    premiumAmount: "",
    currency: "QAR",
    plan: "",
    policyCovers: "",
  };

  const [vehicleDetails, setVehicleDetails] = useState(initialVehicleDetails);
  const [policyDetails, setPolicyDetails] = useState(initialPolicyDetails);
  const [quotes, setQuotes] = useState([]);
  const [loading, setLoading] = useState(true); // ✅ loader starts active
  const [sgsData, setSgsData] = useState(null);
  const [apiError, setApiError] = useState(null);

//   useEffect(() => {
//     const fetchPolicyData = async () => {
//       if (!id) {
//         toast.error("Missing policy ID. Redirecting to home.");
//         navigate("/");
//         return;
//       }

//       try {
//         const response = await fetch(
//           `${CONFIG.BASE}/insurance/getVehicleData`,
//           {
//             method: "POST",
//             headers: { "Content-Type": "application/json" },
//             body: JSON.stringify({ id }),
//           }
//         );

//         if (!response.ok) throw new Error("Failed to retrieve policy data");

//         const userPolicy = await response.json();

//         if (userPolicy.renPolicyNumber) {
//           toast.success("Policy Already Renewed!");
//           navigate("/success", { state: { id: userPolicy.id } });
//           return;
//         }

//         setVehicleDetails({
//           registrationNumber: userPolicy.vehicleRegistrationNumber || "NA",
//           chassisNumber: userPolicy.chassisNumber || "",
//           vehicleUsage: userPolicy.vehUsage || "",
//           manufacturingYear: userPolicy.manufacturingYear || "",
//           expiryDate: userPolicy.insuranceExpiryDate
//             ? new Date(userPolicy.insuranceExpiryDate)
//             : null,
//           vehicleValue: userPolicy.vehicleValue || null,
//           vehMake: userPolicy.vehMake || userPolicy.makeModel,
//           vehModel: userPolicy.vehModel || userPolicy.makeModel,
//           policyType: userPolicy.policyCovers,
//           sumInsuredStatus: userPolicy.sumInsuredStatus,
//           vehicleCylinder: userPolicy.vehCylinder,
//          // vehicleSeats: userPolicy.vehSeat,
//         });

//         setPolicyDetails({
//           insuredName: userPolicy.insuredName || "",
//           policyNumber: userPolicy.policyNumber || "",
//           policyStartDate: userPolicy.policyStartDate
//             ? new Date(userPolicy.policyStartDate)
//             : null,
//           policyExpiryDate: userPolicy.policyExpiryDate
//             ? new Date(userPolicy.policyExpiryDate)
//             : null,
//           premiumAmount: userPolicy.premiumAmount || "",
//           currency: userPolicy.currency || "QAR",
//           coverageType: [],
//         });

//         // ✅ Populate activation & expiration date if present in DB
// if (userPolicy.newPolicyStartDate) {
//   const dbActivation = new Date(userPolicy.newPolicyStartDate);
//   const year = dbActivation.getFullYear();
//   const month = String(dbActivation.getMonth() + 1).padStart(2, "0");
//   const day = String(dbActivation.getDate()).padStart(2, "0");
//   setActivationDate(`${year}-${month}-${day}`); // "YYYY-MM-DD"
// }

// if (userPolicy.newPolicyExpiryDate) {
//   const dbExpiry = new Date(userPolicy.newPolicyExpiryDate);
//   const year = dbExpiry.getFullYear();
//   const month = String(dbExpiry.getMonth() + 1).padStart(2, "0");
//   const day = String(dbExpiry.getDate()).padStart(2, "0");

//   // 🔒 Always set expiry time to 23:59
//   setExpirationDate(`${year}-${month}-${day}T23:59`);
// }


//         setQuotes([
//           {
//             name: userPolicy.existingPlan || "",
//             premium: userPolicy.premiumAmount || "",
//             image: "/images/" + (userPolicy.existingPlan || "default") + ".png",
//             coverages: userPolicy.policyCovers
//               ? userPolicy.policyCovers.split(",")
//               : [],
//           },
//         ]);

//         if (!userPolicy.renProposalNumber) {
//           const proposalResponse = await fetch(
//             `${CONFIG.BASE}/insurance/generate-proposal`,
//             {
//               method: "POST",
//               headers: { "Content-Type": "application/json" },
//               body: JSON.stringify({ irgSgsId: id, selectPlan: 0 }),
//             }
//           );

//           if (!proposalResponse.ok)
//             throw new Error("Failed to generate proposal");

//           const proposalData = await proposalResponse.json();

//           // if (proposalData.errorCode && proposalData.errorCode !== "1") {
//           //   setApiError(
//           //     proposalData.errorMsg || "An unexpected error occurred."
//           //   );
//           //   return;
//           // }

//           setSgsData(proposalData);
//           console.log("Proposal data on load:", proposalData);
//         } else {
//           console.log(
//             "Existing proposal found. Skipping generate-proposal API call."
//           );
//         }
//         // if (!userPolicy.vehUsage || !userPolicy.vehCylinder || !userPolicy.vehSeat) {
//         //   setTimeout(fetchPolicyData, 1000); // re-fetch after 2 seconds
//         //   console.log("Some fields are empty, condition checked once.");
//         // }

//         // ✅ Check once only
// if (!userPolicy.vehUsage || !userPolicy.vehCylinder) {

//   if (!hasRetried.current) {
//     hasRetried.current = true;  // mark retry done
//     console.log("Some fields are empty, re-fetching once...");
//     setTimeout(fetchPolicyData, 1000);
//   } else {
//     console.log("Fields still empty — stopping retries.");
//   }

//   return; // ✅ stop executing further
// }

//       } catch (error) {
//         console.error("Error fetching policy or proposal:", error);
//         toast.error("Unable to load policy or proposal details.");
//         navigate("/");
//       } finally {
//         setLoading(false); // ✅ stop loader after attempt
//       }
//     };

//     fetchPolicyData();
//   }, [id, navigate]);

useEffect(() => {
  const fetchPolicyData = async () => {
    console.log("🔹 fetchPolicyData triggered for id:", id);

    if (!id) {
      toast.error("Missing policy ID. Redirecting to home.");
      navigate("/");
      return;
    }

    try {
      console.log("⏳ Fetching vehicle data from API...");
      const response = await fetch(`${CONFIG.BASE}/insurance/getVehicleData`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id }),
      });

      if (!response.ok) throw new Error("Failed to retrieve policy data");

      const userPolicy = await response.json();
      console.log("✅ Vehicle data received:", userPolicy);

      if (userPolicy.renPolicyNumber) {
        toast.success("Policy Already Renewed!");
        navigate("/success", { state: { id: userPolicy.id } });
        return;
      }

      // -------------------- Vehicle Details --------------------
      setVehicleDetails({
        registrationNumber: userPolicy.vehicleRegistrationNumber || "NA",
        chassisNumber: userPolicy.chassisNumber || "",
        vehicleUsage: userPolicy.vehUsage || "",
        manufacturingYear: userPolicy.manufacturingYear || "",
        expiryDate: userPolicy.insuranceExpiryDate
          ? new Date(userPolicy.insuranceExpiryDate)
          : null,
        vehicleValue: userPolicy.vehicleValue || null,
        vehMake: userPolicy.vehMake || userPolicy.makeModel,
        vehModel: userPolicy.vehModel || userPolicy.makeModel,
        policyType: userPolicy.policyCovers,
        sumInsuredStatus: userPolicy.sumInsuredStatus,
        vehicleCylinder: userPolicy.vehCylinder,
      });
      console.log("🚗 Vehicle details set:", userPolicy.vehicleRegistrationNumber);

      // -------------------- Policy Details --------------------
      setPolicyDetails({
        insuredName: userPolicy.insuredName || "",
        policyNumber: userPolicy.policyNumber || "",
        policyStartDate: userPolicy.policyStartDate
          ? new Date(userPolicy.policyStartDate)
          : null,
        policyExpiryDate: userPolicy.policyExpiryDate
          ? new Date(userPolicy.policyExpiryDate)
          : null,
        premiumAmount: userPolicy.premiumAmount || "",
        currency: userPolicy.currency || "QAR",
        coverageType: [],
      });
      console.log("📄 Policy details set:", userPolicy.policyNumber);

      // -------------------- Activation & Expiration --------------------
      if (userPolicy.newPolicyStartDate) {
        const dbActivation = new Date(userPolicy.newPolicyStartDate);
        const year = dbActivation.getFullYear();
        const month = String(dbActivation.getMonth() + 1).padStart(2, "0");
        const day = String(dbActivation.getDate()).padStart(2, "0");
        setActivationDate(`${year}-${month}-${day}`);
        console.log("📅 Activation date set from DB:", `${year}-${month}-${day}`);
      }

      if (userPolicy.newPolicyExpiryDate) {
        const dbExpiry = new Date(userPolicy.newPolicyExpiryDate);
        const year = dbExpiry.getFullYear();
        const month = String(dbExpiry.getMonth() + 1).padStart(2, "0");
        const day = String(dbExpiry.getDate()).padStart(2, "0");
        setExpirationDate(`${year}-${month}-${day}T23:59`);
        console.log("📅 Expiration date set from DB:", `${year}-${month}-${day}T23:59`);
      }

      // -------------------- Quotes --------------------
      setQuotes([
        {
          name: userPolicy.existingPlan || "",
          premium: userPolicy.premiumAmount || "",
          image: "/images/" + (userPolicy.existingPlan || "default") + ".png",
          coverages: userPolicy.policyCovers
            ? userPolicy.policyCovers.split(",")
            : [],
        },
      ]);
      console.log("📝 Quotes set:", userPolicy.existingPlan || "null");

      // -------------------- Proposal --------------------
      if (!userPolicy.renProposalNumber) {
        const proposalResponse = await fetch(`${CONFIG.BASE}/insurance/generate-proposal`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ irgSgsId: id, selectPlan: 0 }),
        });

        if (!proposalResponse.ok)
          throw new Error("Failed to generate proposal");

        const proposalData = await proposalResponse.json();
        setSgsData(proposalData);
        console.log("📊 Proposal data on load:", proposalData);
      } else {
        console.log("ℹ️ Existing proposal found. Skipping generate-proposal API call.");
      }

      // -------------------- Lead Email Logic --------------------
const leadFlagKey = `leadEmailSent-${id}`;
if (!localStorage.getItem(leadFlagKey)) {
  console.log("📤 Sending lead email...");

  // ✅ Set the flag immediately to prevent duplicate sends on refresh
  localStorage.setItem(leadFlagKey, "true");

  fetch(`${CONFIG.MAIL}/notify-lead-viewed/${id}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email: userPolicy.email }),
  })
    .then((res) => {
      if (res.ok) {
        console.log("✅ Lead email sent successfully");
      } else {
        console.error("❌ Failed to send lead email, status:", res.status);
        // Optional: remove the flag to allow retry later
        localStorage.removeItem(leadFlagKey);
      }
    })
    .catch((err) => {
      console.error("❌ Error sending lead email:", err);
      // Optional: remove the flag to allow retry later
      localStorage.removeItem(leadFlagKey);
    });
} else {
  console.log("ℹ️ Lead email already sent previously, skipping...");
}

      // -------------------- Retry Logic --------------------
      if (!userPolicy.vehUsage || !userPolicy.vehCylinder) {
        if (!hasRetried.current) {
          hasRetried.current = true;
          console.log("⚠️ Some fields empty, re-fetching once...");
          setTimeout(fetchPolicyData, 1000);
        } else {
          console.log("ℹ️ Fields still empty — stopping retries.");
        }
        return; // stop further execution
      }

    } catch (error) {
      console.error("❌ Error fetching policy or proposal:", error);
      toast.error("Unable to load policy or proposal details.");
      navigate("/");
    } finally {
      setLoading(false);
      console.log("⏹ Loading stopped");
    }
  };

  fetchPolicyData();
}, [id, navigate]);

  const handleCoverageChange = (e) => {
    const { value } = e.target;
    setPolicyDetails((prev) => ({ ...prev, coverageType: [value] }));
  };

  const handleFormReset = () => {
    setVehicleDetails(initialVehicleDetails);
    setPolicyDetails(initialPolicyDetails);
    setQuotes([]);
    toast.info("Form reset successfully!", {
      position: "top-right",
      autoClose: 2000,
    });
    navigate("/");
  };

  const [activationDate, setActivationDate] = useState("");
  const [expirationDate, setExpirationDate] = useState("");

  const handleActivationDateChange = (e) => {
    const selectedDate = e.target.value; // YYYY-MM-DD string
    if (!selectedDate) {
      setActivationDate("");
      setExpirationDate("");
      return;
    }

    if (!policyDetails.policyExpiryDate) {
      toast.error("Existing policy expiry date is not loaded yet!");
      return;
    }

    // Convert both dates to Date objects at local midnight
    const activation = new Date(selectedDate + "T00:00:00");
    const existingExpiry = new Date(policyDetails.policyExpiryDate);
    existingExpiry.setHours(0, 0, 0, 0); // normalize time to midnight

    if (activation <= existingExpiry) {
      toast.error(
        "Activation date must be greater than the existing policy expiry date!"
      );
      setActivationDate(""); // reset field
      setExpirationDate("");
      return;
    }

    // ✅ Valid activation date
    setActivationDate(selectedDate);

    // Calculate expiration date 1 year from activation
    const expiry = new Date(activation);
    expiry.setDate(expiry.getDate() + 365 - 1);
    expiry.setHours(23, 59, 0, 0);

    const year = expiry.getFullYear();
    const month = String(expiry.getMonth() + 1).padStart(2, "0");
    const day = String(expiry.getDate()).padStart(2, "0");
    const hours = String(expiry.getHours()).padStart(2, "0");
    const minutes = String(expiry.getMinutes()).padStart(2, "0");

    setExpirationDate(`${year}-${month}-${day}T${hours}:${minutes}`);
  };

  const today = new Date().toISOString().split("T")[0];

  useEffect(() => {
    // 🔹 Load saved dates from localStorage (if any) when page mounts
    const savedActivation = localStorage.getItem("activationDate");
    const savedExpiration = localStorage.getItem("expirationDate");
  
    if (savedActivation) setActivationDate(savedActivation);
    if (savedExpiration) setExpirationDate(savedExpiration);
  }, []);
  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const activation = new Date(activationDate);
    const strictExpiry = new Date(policyDetails.policyExpiryDate);

    console.log("strictExpiry", strictExpiry);
    
    console.log("registrstion");

    // if (activation <= strictExpiry) {
    //   toast.error(
    //     "Activation date must be greater than the existing policy expiry date!"
    //   );
    //   setLoading(false);
    //   return;
    // }

    // ✅ Validation checks
    if (!policyDetails.insuredName) {
      toast.error("Insured Name is missing!");
      setLoading(false);
      return;
    }
    if (!policyDetails.policyNumber) {
      toast.error("Policy Number is missing!");
      setLoading(false);
      return;
    }
 
    if (!vehicleDetails.chassisNumber) {
      toast.error("Chassis Number is missing!");
      setLoading(false);
      return;
    }
    if (!vehicleDetails.vehMake || !vehicleDetails.vehModel) {
      toast.error("Vehicle Make & Model are missing!");
      setLoading(false);
      return;
    }
    if (!policyDetails.policyStartDate || !policyDetails.policyExpiryDate) {
      toast.error("Existing Policy Dates are missing!");
      setLoading(false);
      return;
    }
    if (!activationDate) {
      toast.error("Please select an Activation Date!");
      setLoading(false);
      return;
    }
    if (!expirationDate) {
      toast.error("Expiration Date is not calculated!");
      setLoading(false);
      return;
    }

    try {
      // ✅ Pass activationDate & expirationDate in state
      localStorage.setItem("activationDate", activationDate);
      localStorage.setItem("expirationDate", expirationDate);
      navigate("/plan", {
        state: {
          id,
          passedActivationDate: activationDate,
          passedExpirationDate: expirationDate,
        },
      });
      // navigate("/scanner", {
      //   state: {
      //     id,
      //    activationDate,
      //   expirationDate,
      //   },
      // });
    } catch (error) {
      toast.error(`Error: ${error.message}`, {
        position: "top-right",
        autoClose: 3000,
      });
      setLoading(false);
    }
  };

  const formattedVehicleValue = new Intl.NumberFormat().format(
    vehicleDetails.vehicleValue
  );

  useEffect(() => {
    if (apiError) {
      const timer = setTimeout(() => {
        navigate("/");
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, [apiError, navigate]);

  // ✅ Loader screen
  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
        <div
          className="spinner-border text-primary"
          style={{ width: "4rem", height: "4rem" }}
        />
      </div>
    );
  }

  // if (apiError) {
  //   return (
  //     <div className="container d-flex flex-column justify-content-center align-items-center vh-100 text-center">
  //       <div
  //         className="card shadow-lg p-5 w-100 border-0"
  //         style={{ maxWidth: "650px" }}
  //       >
  //         <h2 className="text-danger mb-4">⚠️ Renewal requires Approval</h2>
  //         <p className="fs-5">{apiError}</p>
  //         <p className="text-muted">
  //           You will be redirected to the Home screen shortly...
  //         </p>
  //       </div>
  //     </div>
  //   );
  // }

  // --- helpers ---
  function startOfToday() {
    const d = new Date();
    d.setHours(0, 0, 0, 0);
    return d;
  }

  function addDays(date, days) {
    const d = new Date(date);
    d.setDate(d.getDate() + days);
    d.setHours(0, 0, 0, 0);
    return d;
  }

  function toInputDateLocal(date) {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, "0");
    const d = String(date.getDate()).padStart(2, "0");
    return `${y}-${m}-${d}`;
  }

  // --- parse backend expiry safely (replace with your parser if Oracle format) ---
  const expiry = new Date(policyDetails.policyExpiryDate);
  expiry.setHours(0, 0, 0, 0);

  const todays = startOfToday();
  let minDate;

  // 1. Policy expired before today → allow today
  if (expiry < todays) {
    minDate = todays;
  }
  // 2. Policy expires today → must pick tomorrow
  else if (expiry.getTime() === todays.getTime()) {
    minDate = addDays(todays, 1);
  }
  // 3. Policy expires in future → must pick strictly after expiry
  else {
    minDate = addDays(expiry, 1);
  }

  const minForInput = toInputDateLocal(minDate);

  return (
    <>
      <div className="container">
        <div className="row gy-4">
          {/* Policy Terms */}
          <div className="col-md-6">
            <div className="card shadow p-4">
              <h4 className="text-center" style={{ color: "#1d2671" }}>
                📜 Policy Terms
              </h4>
              <form>
                <div className="mb-3">
                  <label className="form-label">Insured Name</label>
                  <input
                    type="text"
                    className="form-control"
                    value={policyDetails.insuredName}
                    readOnly
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">Existing Policy Number</label>
                  <input
                    type="text"
                    className="form-control"
                    value={policyDetails.policyNumber}
                    readOnly
                  />
                </div>

                <div className="d-flex gap-3 mb-3">
                  <div className="w-50">
                    <label className="form-label">Start Date</label>
                    <DatePicker
                      selected={policyDetails.policyStartDate}
                      className="form-control"
                      dateFormat="dd MMM yyyy" // <-- Formats as "Sep 2025"
                      readOnly
                    />
                  </div>
                  <div className="w-50">
                    <label className="form-label">Expiry Date</label>
                    <DatePicker
                      selected={policyDetails.policyExpiryDate}
                      className="form-control"
                      dateFormat="dd MMM yyyy" // <-- Formats as "Sep 2025"
                      readOnly
                    />
                  </div>
                </div>
                <div className="row mb-3">
                  {/* <div className="col">
                    <label className="form-label">Vehicle Seats</label>
                    <input
                      type="text"
                      className="form-control"
                      value={vehicleDetails.vehicleSeats}
                      readOnly
                    />
                  </div> */}
                  <div className="col">
                    <label className="form-label">Vehicle Cylinder</label>
                    <input
                      type="text"
                      className="form-control"
                      value={vehicleDetails.vehicleCylinder}
                      readOnly
                    />
                  </div>
                </div>
                <div className="mb-3">
                  <label className="form-label">Coverage Type</label>
                  <input
                    type="text"
                    className="form-control"
                    value={vehicleDetails.policyType}
                    readOnly
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Manufacturing Year</label>
                  <input
                    type="text"
                    className="form-control"
                    value={vehicleDetails.manufacturingYear}
                    readOnly
                  />
                </div>
              </form>
            </div>
          </div>

          {/* Premium Details */}
          <div className="col-md-6">
            <div className="card shadow p-4">
              <h4 className="text-center" style={{ color: "#1d2671" }}>
                💰Renewal Details
              </h4>
              <form>
                <div className="mb-3 d-flex gap-3">
                  <div className="w-50">
                    <label className="form-label">Activation Date</label>
                    <input
                      type="date"
                      className="form-control custom-date-input"
                      value={activationDate}
                      min={minForInput}
                      onChange={handleActivationDateChange}
                    />
                  </div>
                  <div className="w-50">
                    <label className="form-label">Expiration Date</label>
                    <input
                      type="datetime-local"
                      className="form-control"
                      value={expirationDate}
                      readOnly
                    />
                  </div>
                </div>
                {/* <div className="row mb-3"> */}
                  <div className="col mb-3">
                    <label className="form-label">Reg No</label>
                    <input
                      type="text"
                      className="form-control"
                      value={vehicleDetails.registrationNumber}
                      readOnly
                    />
                  </div>
                  <div className="col mb-3">
                    <label className="form-label">Chassis Number</label>
                    <input
                      type="text"
                      className="form-control"
                      value={vehicleDetails.chassisNumber}
                      readOnly
                    />
                  </div>
                {/* </div> */}

                {vehicleDetails.sumInsuredStatus === "Y" && (
                  <div className="mb-3">
                    <label className="form-label">Vehicle Value (15% depreciation applied)</label>
                    <input
                      type="text"
                      className="form-control"
                      value={formattedVehicleValue}
                      readOnly
                    />
                  </div>
                )}

                {/* <div className="mb-3">
                  <label className="form-label">Usage</label>
                  <input
                    type="text"
                    className="form-control"
                    value={vehicleDetails.vehicleUsage}
                    readOnly
                  />
                </div> */}

                <div className="mb-3">
                  <label className="form-label">Make</label>
                  <input
                    type="text"
                    className="form-control"
                    value={vehicleDetails.vehMake}
                    readOnly
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">Model</label>
                  <input
                    type="text"
                    className="form-control"
                    value={vehicleDetails.vehModel}
                    readOnly
                  />
                </div>
              </form>
            </div>

            <div className="d-flex justify-content-end align-items-center gap-3 mt-4 mb-4">
              <button className="cancel-btn" onClick={() => navigate(-1)}>
                Back
              </button>

              <button
                className="btn btn-success px-4"
                type="submit"
                onClick={handleFormSubmit}
                disabled={loading}
              >
                {loading ? (
                  <span className="spinner-border spinner-border-sm"></span>
                ) : (
                  "Proceed"
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MotorPolicy;
